// Colors from the Bluprintx brand stylesheet.
export const brand = {
  blue: '#2d62ff',
  blueLight: '#d9e5ff',
  blueSoft: '#8fa9ff',
  navy: '#080331',
  navyMuted: '#16124a',
  pink: '#dd23bb',
  pinkLight: '#ffaefe',
  pinkDark: '#3c043b',
  slate: '#6e8894',
  ink: '#131313',
  green: '#85baa1',
  orange: '#db8356',
  purple: '#837897',
  sand: '#cbc087',
} as const;

export const fontFamily =
  '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
